@if (accaCms && accaCms.enabled) {
    <div class="acca-content" data-crlat="accaContent" [ngClass]="{ 'up-cell': isbsFloater, 'bs': id == 'betslipSp', 'quacca-bar': isQuacca }">
        @if (templateType === 'SP' && showSP(id)) {
            <div
                data-crlat="signPost"
                class="sign-post"
                [ngClass]="{ 'desktop': isDesktop, 'coral-text': isDesktop && isCoral, 'mobile': !isDesktop && isCoral }">
                <span class="svg-cont" [ngClass]="{ 'coral-desk': isCoral && isDesktop }" data-crlat="svgCont">
                    <!-- <ng-container *ngIf="issvgFirst; else svgFirst"> -->
                    @if (issvgFirst) {
                        <svg class="five-svg" data-crlat="fiveSvg" [ngClass]="{ 'five-icn-coral': isCoral, 'quacca-bar-svg': isQuacca }">
                            <use [attr.xlink:href]="'#' + accaCms.svgId"></use>
                        </svg>
                        <span
                            *ngIf="!isQuacca"
                            class="text"
                            data-crlat="accaText"
                            [ngClass]="{ 'five-desk': isDesktop, 'coral': isCoral }"
                            [textContent]="getTxt(accaCms.mybetsSp.mbsp)"></span>
                        <span
                            *ngIf="isQuacca"
                            class="text"
                            data-crlat="accaText"
                            [ngClass]="{ 'five-desk': isDesktop, 'coral': isCoral }"
                            [textContent]="'insurance'"></span>
                    } @else {
                        <span
                            *ngIf="!isQuacca"
                            class="text svg"
                            data-crlat="accaText"
                            [ngClass]="{ 'five-desk': isDesktop, 'coral': isCoral }"
                            [textContent]="getTxt(accaCms.mybetsSp.mbsp)"></span>
                        <span
                            *ngIf="isQuacca"
                            class="text"
                            data-crlat="accaText"
                            [ngClass]="{ 'five-desk': isDesktop, 'coral': isCoral }"
                            [textContent]="'insurance'"></span>
                        <svg class="five-svg" data-crlat="fiveSvg" [ngClass]="{ 'five-icn-coral': isCoral, 'quacca-bar-svg': isQuacca }">
                            <use [attr.xlink:href]="'#' + accaCms.svgId"></use>
                        </svg>
                    }
                </span>
                @if (variation != 2 && upSellData?.length && showSP(id, progressBar)) {
                    <div
                        class="acca-container"
                        data-crlat="acca-bar"
                        [ngClass]="{ 'desktop': isDesktop, 'coral-desk': isDesktop && isCoral, 'quacca-bar': isQuacca }">
                        <!-- [ngClass]="{'progress-bar': isDesktop}">-->
                        <ul class="acca-indicator">
                            @for (tile of upSellData; track $index) {
                                <li
                                    class="item"
                                    data-crlat="itemFilled"
                                    [ngClass]="{ filled: tile.filled, empty: !tile.filled }"
                                    [ngStyle]="{ width: calculateWidth() }"></li>
                            }
                        </ul>
                    </div>
                }
            </div>
        }

        @if (templateType === 'QUALIFY' && showSP(id)) {
            <div (click)="onClick()" class="qualify">
                <div class="five-acca">
                    <svg data-crlat="fiveIcn" class="five" [ngClass]="{ desktop: isDesktop }">
                        <use [attr.xlink:href]="'#' + accaCms.svgId"></use>
                    </svg>
                </div>
                <div class="qualify-text" [ngClass]="{ desktop: isDesktop }">
                    <span [textContent]="getTxt(accaCms.profitIndi)"></span>
                </div>
                <div class="next-arrow">
                    <svg class="arrow">
                        <use xlink:href="#next-arrow"></use>
                    </svg>
                </div>
            </div>
        }
    </div>
}
